import React, { useState, useEffect } from "react";
import { fetchCurrentUser, fetchWithAuth } from "../../../api-client/APIClient";
import { IntegrationIssue } from "../IntegrationsManagementEntities";
import DashboardIssues from "./DashboardIssues";
import DashboardLinkedIntegrations from "./DashboardLinkedIntegrations";
import { LinkedIntegration } from "../../../models/Entities";
import { OrganizationInviteAlert } from "../../shared/banners/OrganizationInviteAlert";
import { isBillingPlanFreeLaunch } from "../settings/billing/BillingUtils";
import useAppContext from "../../context/useAppContext";
import PortalPageHeaderWrapper from "../../portal/PortalPageHeaderWrapper";
import * as Frigade from "@frigade/react";
import LinkedAccountsCountsCard from "../../shared/LinkedAccountsCountsCard";
import DashboardSyncFrequency from "./DashboardSyncFrequency";
import DashboardUpsellCard from "./DashboardUpsellCard";
import DashboardQuickLinks from "./DashboardQuickLinks";

function Dashboard() {
  const [integrationIssues, setIntegrationIssues] = useState<Array<IntegrationIssue> | undefined>();
  const [linkedIntegrations, setLinkedIntegrations] = useState<Array<LinkedIntegration>>();
  const { user, setUser } = useAppContext();

  const { addProperties: addFrigadeGroupProperties } = Frigade.useGroup();

  useEffect(() => {
    fetchWithAuth({
      path: "/integrations/linked-accounts/count",
      method: "GET",
      onResponse: (data) => {
        setLinkedIntegrations(data);
      },
    });
    fetchWithAuth({
      path: "/integrations/issues?include_muted=false",
      method: "GET",
      onResponse: (data) => {
        setIntegrationIssues(data.results);
      },
    });
    if (!user) {
      fetchCurrentUser(setUser);
    }
    if (user.show_upgrade_billing_plan_banner) {
      fetchWithAuth({
        path: "/users/me",
        method: "PATCH",
        body: { show_upgrade_billing_plan_banner: false },
        onResponse: () => {},
      });
    }
  }, []);

  return (
    <PortalPageHeaderWrapper title="Dashboard">
      <>
        <OrganizationInviteAlert />
        <div className="flex flex-wrap -mx-4">
          <div className="xl:w-9/12 w-full px-4 pb-4 flex flex-col space-y-4">
            <DashboardIssues integrationIssues={integrationIssues} />
            <DashboardLinkedIntegrations integrations={linkedIntegrations} />
          </div>

          <div className="xl:w-3/12 w-full px-4 flex flex-col space-y-4">
            <LinkedAccountsCountsCard />
            <DashboardSyncFrequency />
            <DashboardQuickLinks />
            {isBillingPlanFreeLaunch(user.organization.organization_billing_plan?.billing_plan) && (
              <DashboardUpsellCard />
            )}
          </div>
        </div>
      </>
    </PortalPageHeaderWrapper>
  );
}

export default Dashboard;
